var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartners4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 16,
    viewBox: "0 0 191 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3208_5971",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 191,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.713501,
    width: 190,
    height: 16,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3208_5971)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.2865,
    y: -16,
    width: 211,
    height: 46,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3208_5971",
    transform: "scale(0.00526316 0.0625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3208_5971",
    width: 190,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL4AAAAQCAYAAACoYsUDAAAEcklEQVRogeVaMXJbNxB9m0nlxryBeIP8G5g+gekThDcIU6Sm1KaRfIGI7tKJPoHImfSkS1eSJ2UKUSd4KbB/hL8ETSw+SHrGb4YzIgVg9wP7dx8eICRneMEXEfkbB0ByAuDiULtv4JOIbHr0j31pALwBMNjTZCkiq8KxRzp2i88isnD078yTiFwV+jEA8AuAUUl/ACsRWRb2jf0Yqx8tPorIY4Vx/wDwSr/+KyJ/ZfbrrI9rftnFp8w+S/bHPclhtqO7PlySfHDYu/XaUxs74zj6d+bJ/5RhcZ3PmcJliW3jx5Dkkxn3vu+4OvZ/0Zj/OPp11sdj8ye/m9UwAnDPkM2yQbIhuQYwA+AJ5AmANUPW6oMJyTuv3yVgeFHv4HvOY2GO3ao6Ijk9hzN9cc7AB8KC3uQ21kC4B9AU2hsAuGOgIH0wRnhpjx2QN9hP4U4GDe43e/49O8E8VMfPlcZ562jbALiOvr9z9E1lnRWApX5SthoAv5rfr0kuRGTrsJ0ae03yba39yh4bLZ4RqlaJz8U8XIN6Zn5+BvBa/x4AuIUvBs4Pw9mKOH6BTXd/Bq5rkUVblB5tTN+DlcZySJLThA9P+ypIhXmKsfb2rwH7DPp9SHJr56aHjZNz/CoZn+S+MphCq1C0eM7sZ4P891yFRUQ2Gpxx8LwD4FosEbkhuUWgIJ2MR/KiVLX5BlZ4oRiNY3G3ADYAFgjKS1Fl4y7FeQYwEZFHhg1zXLlnJOc9q+jpYN7aU6o6LeaFNt3c146R0T6ZURgqiM14pFF8vPYS9sc955Yk1yzg4EyrOFPTxq7JndeOjvNDqTpAyCC9pbZTQzn9EMBn86+JBlqVDalWtA89h2kQOLgXdj+1EhFLDyfoVuwx+6tmJ8E5A/8rgJHjAMRuIF3KDF8OumL7xdCSPgJgq2S76S1VnqydKYD3aqfU55HHH6ZVnAeSs/iDIBo8mHa3tV78Y6KWqpPitvaUDwjc8wOAjecEVLEA8Fv0/Zrkk4h8PNRRF91mPa/9HWjwjxk2yrFvrexahe/qXLn8ZdjTxM88xG7ySPVLqThAfqJpVZ73me3PgiqBLyI7dEWDYYlu8A8AXKTaZ9hYkow3ewAw1wVeIiyqDbRWzrSLVpViiciU5AbdQBugpwavL+zrgw3TsBk79yVMScZejEmOC5JbL9AjspjNSVU5k+QgsQEiC08+mZbRSpCVvejcPDFIrnv9K3jemiLCwflmWq4txVOOTbVbZXPrQS2qk0TLgxmUm/gQaQxgyHD4k00HVEYbIWQlS6Ny0MpxR8lEWpX6+HcsXB2aZ6YpzhXSB4P7cImXSvN9Ux7zIhztAIvkPPHiFSsgDNnpMfMF36p9772gIrmModLZA7NzZfysKyEJW+7bnExX5IMqD8+U8WOu+yXT5hy+TAARmTDw4J2LTijYaKq0dsPAgxukL3JtETbSpVdyi/ppdm0Y1JE+fNk9zxG2ABY5qhlDtrfXPrLOV2JoRZ6ge9Ui5wzhT0TXkh0mi69a/w/j0Mx/SNyLxwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners4);
export default __webpack_public_path__ + "static/media/partners4.d2fb96ff1eb1a821d3bdb08270bcfd9f.svg";
export { ForwardRef as ReactComponent };